import { FC } from 'react'
import { Space, Tabs, TabsProps } from 'antd'
import { translate } from '../../../core'
import { InfoTooltip } from '../../../core/component'
import { ImageSliderListDefault } from './ImageSliderListDefault'
import { ImageSliderListSecond } from './ImageSliderListSecond'

export const ImageSlider: FC = () => {
  const tabs: TabsProps['items'] = [
    {
      key: 'default',
      label: (
        <Space size={4}>
          {translate('main')}
          <InfoTooltip contentKey='imageSlider.main' placement='right' />
        </Space>
      ),
      children: <ImageSliderListDefault/>,
    },
  ]

  return (
    <Tabs
      tabPosition='left'
      defaultActiveKey='default'
      items={tabs}
    />
  )
}